module.exports = __webpack_public_path__ + "media/img/frontend_application/footericon/youtube-7622525ac56a5f4d2ca5d68baa8f95a7.svg";